import { useCurrentRoleStore } from '~/stores/currentRole'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  if (!config.public.billingActivityEnabled) return

  const user = useSupabaseUser()
  const route = useRoute()
  const { currentRole } = storeToRefs(useCurrentRoleStore())

  watch(
    [() => user.value?.id, () => currentRole.value?.schoolId, () => route.path],
    async ([userId, schoolId]) => {
      if (!userId || !schoolId) return

      const month = new Date().toISOString().slice(0, 7)
      const storageKey = `billing-activity:${schoolId}:${userId}:${month}`
      if (localStorage.getItem(storageKey)) return

      try {
        await $fetch('/api/billing/activity', {
          method: 'POST',
          body: { schoolId },
        })
        localStorage.setItem(storageKey, 'recorded')
      } catch (error) {
        console.warn('Monthly activity could not be recorded', error)
      }
    },
    { immediate: true },
  )
})
